export default __webpack_public_path__ + "media/images/engaine-1-d6abc6f6cd037ed4ff068ba372fff96f.png";